import { Link } from 'react-router-dom';
import { Container, Button } from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { BsFillCaretUpFill } from 'react-icons/bs';
import { bottomTotop, useBlcNavScroll } from '../../Blc_Business/BlcHomeLandingPage/HomeWindowThree';
import { BsInstagram, BsFacebook } from 'react-icons/bs';
import './blc_footertwo.css';


const Blc_FooterTwoCopy = (props) => {

    const blcScroll = useBlcNavScroll();
    // console.log(props.val.footerlowertwo);

    return (
        <Container fluid className='smallSreen'>
            <Container className='smallSreen pt-4 pb-2'>
                <Row>
                    <Col lg={6} className='mb-4'>
                        <img
                            alt="blc footer logo"
                            className="footer-logo"
                            src="https://blcload.brac.net/small_logo_wgite_067ad14efa_952fdedd1b/small_logo_wgite_067ad14efa_952fdedd1b.png"
                        />
                        {/* <hr style={{ width: '92%', color: 'gray', padding: '1px' }} /> */}

                        <div className='ms-2 mt-4'>
                            {/* <div className="footer-social-container my-4">
                                <BsFacebook href='https://github.com/Swift71/BLC-Frontend/tree/blc_v3/src/Blc_Home/HomeNav' size={22}></BsFacebook>
                                <BsInstagram size={22}></BsInstagram>
                            </div> */}
                            <p className="footer-s-one">Tel: <a className="link-color" href="tel:+8801313407157" rel="noopener noreferrer" target="_blank"> {props.val.blc_contact_phone} </a> &nbsp;
                                <br />
                                <br />
                                E-mail:<a className="link-color" href="mailto: blc.communications@brac.net" rel="noopener noreferrer" target="_blank"> {props.val.blc_contact_email}</a>
                                <br />
                                <br />
                                {props.val.blc_contact_address}</p>
                        </div>

                    </Col>
                    <Col lg={6}>
                        <Row className='mb-4'>
                            <div className='mb-2'>
                                <h4 className='footer-sub-h'>Locations</h4>
                                <hr style={{ height: '1px', width: '4rem' }} />
                            </div>
                            <Col md={3} lg={3} sm={6} xs={6} className='mb-4'>

                                <li>
                                    <Link to="/locations/Gulshan">
                                        <a className="link-color-footer">Gulshan</a>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/locations/Uttara">
                                        <a className="link-color-footer">Uttara</a>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/locations/Barishal">
                                        <a className="link-color-footer">Barishal</a>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/locations/Bogura">
                                        <a className="link-color-footer">Bogura</a>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/locations/Chattogram">
                                        <a className="link-color-footer">Chattogram</a>
                                    </Link>
                                </li>

                            </Col>
                            <Col md={3} lg={3} sm={6} xs={6} className='mb-4'>

                                <li>
                                    <Link to="/locations/Cox's-Bazar">
                                        <a className="link-color-footer">Cox's Bazar</a>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/locations/Cumilla">
                                        <a className="link-color-footer">Cumilla</a>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/locations/Dinajpur">
                                        <a className="link-color-footer">Dinajpur</a>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/locations/Faridpur">
                                        <a className="link-color-footer">Faridpur</a>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/locations/Jashore">
                                        <a className="link-color-footer">Jashore</a>
                                    </Link>
                                </li>

                            </Col>
                            <Col md={3} lg={3} sm={6} xs={6} className='mb-4'>

                                <li>
                                    <Link to="/locations/Khulna">
                                        <a className="link-color-footer">Khulna</a>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/locations/Madhupur">
                                        <a className="link-color-footer">Madhupur</a>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/locations/Mymensingh">
                                        <a className="link-color-footer">Mymensingh</a>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/locations/Pabna">
                                        <a className="link-color-footer">Pabna</a>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/locations/Rajshahi">
                                        <a className="link-color-footer">Rajshahi</a>
                                    </Link>
                                </li>

                            </Col>
                            <Col md={3} lg={3} sm={6} xs={6} className='mb-4'>

                                <li>
                                    <Link to="/locations/Rangpur">
                                        <a className="link-color-footer">Rangpur</a>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/locations/Sreemangal">
                                        <a className="link-color-footer">Sreemangal</a>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/locations/Sylhet">
                                        <a className="link-color-footer">Sylhet</a>
                                    </Link>
                                </li>

                            </Col>

                        </Row>
                        <Row>
                            <Col md={3} lg={3} sm={6} xs={6} className='mb-4'>
                                <div className='mb-4'>
                                    <h4 className='footer-sub-h'>About</h4>
                                    <hr style={{ height: '1px', width: '4rem' }} />
                                </div>

                                <li>
                                    <Link to="/">
                                        <a className="link-color-footer" href="">Home</a>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/facilities">
                                        <a className="link-color-footer" href="">Pricing</a>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/gallery">
                                        <a className="link-color-footer" href="">Gallery</a>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/allnews">
                                        <a className="link-color-footer" href="">Blogs</a>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/reservation">
                                        <a className="link-color-footer" href="">Reservation</a>
                                    </Link>
                                </li>
                            </Col>
                            <Col md={4} lg={4} sm={6} xs={6} className='mb-4'>
                                <div className='mb-4'>
                                    <h4 className='footer-sub-h'>Useful Links</h4>
                                    <hr style={{ height: '1px', width: '4rem' }} />
                                </div>

                                <li><a className="link-color-footer" href="http://brac.net/" rel="noopener noreferrer" target="_blank">More about BRAC</a></li>
                                <li><a className="link-color-footer" href="https://bracinternational.org/" rel="noopener noreferrer" target="_blank">BRAC International</a></li>
                                <li>
                                    <Link to="/allnews">

                                        <a className="link-color-footer" href="">BLC News</a>
                                    </Link>
                                </li>

                                <li>
                                    <Link to="/gallery">
                                        <a className="link-color-footer" href="">BLC Gallery</a>
                                    </Link>
                                </li>
                            </Col>
                            <Col md={3} lg={3} sm={6} xs={6} className='mb-4'>
                                <div className='mb-4'>
                                    <h4 className='footer-sub-h'>Support</h4>
                                    <hr style={{ height: '1px', width: '4rem' }} />
                                </div>
                                <li>
                                    <Link to="/faq">

                                        <a className="link-color-footer">FAQs</a>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/contact">
                                        <a className="link-color-footer">Contact Us</a>
                                    </Link>
                                </li>
                            </Col>
                        </Row>
                    </Col>
                    <hr />
                </Row>
                <Row>
                    <Col className='text-center copyright-text'>&#x000A9; &nbsp;2022 Brac Learning Centre</Col>
                </Row>
            </Container>

            <div className="bottomTotop d-flex justify-content-start">
                <Button className="indicator-btn" onClick={bottomTotop} style={{ transition: '3s ease', display: blcScroll[0] ? 'block' : 'none' }}> <BsFillCaretUpFill size={25} className="py-1" /> </Button>
            </div>
        </Container>
    )
}


export default Blc_FooterTwoCopy;